import React, { useState,useEffect } from 'react';
import { Link, Route,Routes} from 'react-router-dom';
import BottomTab from './BottomTab';

const items = ['Vitals', 'Prescription', 'Reports'];

const MedicalDocument = () => {
    return (
        <div>
          <h1>List of Items</h1>
          <ul>
              <li key='1'><Link to={`/tab2/${items[0]}`}>{items[0]}</Link></li>
              <li key='2'><Link to={`/tab2/${items[1]}`}>{items[1]}</Link></li>
              <li key='3'><Link to={`/tab2/${items[2]}`}>{items[2]}</Link></li>                            
          </ul>
          <BottomTab />
        </div>
      );
    };


export default MedicalDocument;